// Réserves attachées à la réponse chiffrée, jamais déduites de la présence d’un agent sur la carte.
import type { ManqueAffiche } from '../domaine/manques';
import { lienVers } from '../routeur';

export function ReserveCalcul({
  manques,
  nom,
  titre = 'Points à confirmer avant de prendre une décision',
}: {
  manques?: readonly ManqueAffiche[];
  nom?: (id: string) => string;
  titre?: string;
}) {
  if (!manques?.length) return null;
  return (
    <div className="encadre attention" data-testid="reserve-calcul">
      <b>{titre}</b>
      <p>Ces chiffres sont calculés sans les agents d’IA ci-dessous, exclus jusqu’au renseignement de leur zone réseau.</p>
      <ul>
        {manques.map((m, i) => (
          <li key={`${m.objet}-${i}`}>
            <a href={lienVers('carte', { objet: m.objet })}>
              « {m.nom ?? nom?.(m.objet) ?? `Nom non conservé ; identifiant ${m.objet}`} »
            </a>
            {' — '}zone inconnue : à compléter. {m.description}
          </li>
        ))}
      </ul>
    </div>
  );
}

export function ReserveCourte({ manques }: { manques?: readonly ManqueAffiche[] }) {
  return manques?.length ? (
    <small className="note">Calcul hors agents sans zone ; points à confirmer détaillés dans la réserve.</small>
  ) : null;
}
